export default {
  transitionDuration: '250ms'
};